import React from 'react';
import Gallery from './Gallery';

export default function GalleryPage() {
  return <Gallery />;
}
